import { images } from '../constants';
import { FaTree, FaMapSigns, FaCamera, FaCalendarAlt, FaHandshake, FaEnvelope } from 'react-icons/fa';

const services = [  
    {
        id: 1,
        image: images.service1, 
        icon: <FaTree />,
        title: 'Zwiedzanie ogrodu',
        content: 'Ogród można zwiedzać indywidualnie lub w grupach. Serdecznie zapraszamy:',
        paragraphs: [
            'miłośników roślin i ogrodów naturalistycznych,',
            'osoby poszukujące spokojnego spaceru,',
            'rodziny z dziećmi,',
            'turystów odwiedzających Imielno i okolice.',
        ],
        gallery: [
            images.service1Gallery1
        ],
        features: 'Zwiedzanie może obejmować również krótką prelekcję o historii miejsca, roślinach cebulowych oraz koncepcji rewitalizacji ogrodu.',
    },
    {
        id: 2,
        image: images.service2,
        icon: <FaMapSigns />,
        title: 'Oprowadzanie z przewodnikiem',
        content: 'Dla grup zorganizowanych oferujemy:',
        paragraphs: [
            'profesjonalne oprowadzanie po ogrodzie,',
            'opowieści o historii dworu w Imielnie,',
            'prezentację unikalnych roślin,',
            'ciekawostki botaniczne i praktyczne porady ogrodnicze.',
        ],
        gallery: [
            images.service2Gallery1
        ],
        features: 'Oprowadzanie trwa 30–60 minut, w zależności od potrzeb grupy.',
    },
    {
        id: 3,
        image: images.service3,
        icon: <FaCamera />,
        title: 'Sesje zdjęciowe',
        content: 'Ogród w Imielnie to idealne miejsce na:',
        paragraphs: [
            'sesje ślubne,',
            'sesje rodzinne i portretowe,',
            'sesje lifestyle,',
            'nagrania i projekty artystyczne.',
        ],
        gallery: [
            images.service3Gallery1
        ],
        features: 'Zapewniamy piękne scenerie, naturalne światło i intymną atmosferę.',
    },
    {
        id: 4,
        image: images.service4,
        icon: <FaCalendarAlt />,
        title: 'Wydarzenia w ogrodzie',
        content: 'Ogród jest idealnym miejscem na:',
        paragraphs: [
            'kameralne koncerty,',
            'spotkania autorskie,',
            'plenery artystyczne,',
            'wydarzenia tematyczne (np. „Noc w ogrodzie”, „Dzień Cebulowy”).',
        ],
        gallery: [
            images.service4Gallery1
        ],
        features: 'Tworzymy atmosferę, która łączy kulturę, naturę i relaks.',
    },
    {
        id: 5,
        image: images.service5,
        icon: <FaHandshake />,
        title: 'Wynajem przestrzeni',
        content: 'Oferujemy wynajem wybranych części ogrodu na:',
        paragraphs: [
            'eventy firmowe,',
            'rodzinne uroczystości,',
            'małe imprezy plenerowe,',
            'warsztaty i spotkania kreatywne.',
        ],
        gallery: [
            images.service5Gallery1
        ],
        features: 'Każde wydarzenie omawiamy indywidualnie, dbając o spójność z charakterem miejsca..',
    },
    {
        id: 6,
        image: images.service6,
        icon: <FaEnvelope />,
        title: 'Rezerwacje i kontakt',
        content: 'Aby umówić zwiedzanie, wynajem lub zapytać o ofertę, skontaktuj się z nami:',
        paragraphs: [
            'formularz kontaktowy'
        ],
        gallery: [
            images.service6Gallery1
        ],
        features: 'Zapraszamy do Imielna — miejsca, w którym natura mówi własnym językiem.',
    },
];

export default services;